//Imagen
import banner1024 from '../../../Activos/Imagenes/BannerHome/banner1024.svg';

export const ComponenteExtra1024Style = {
    DivStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        paddingLeft: 40,
        paddingRight: 40,
        backgroundImage: 'url(' + banner1024 + ')',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        alignItems: 'center',
        gap: 20,
        height: 119,
        width: 'auto'
    },
    ImgStyle: {
        width: '321px',
        height: '54px',
    },
    DivTextStyle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginLeft: 'auto',
        textAlign: 'right',
        gap: 10
    },
    DescriptionTextStyle: {
        maxWidth: 175,
        color: '#FFFFFF',
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: '24px',
        letterSpacing: 0
    }
};